import { useState } from 'react';

const ConviteSection = () => {
  const [copied, setCopied] = useState(false);
  const shareLink = 'https://cartafuturo.org/?ref=convite';

  const handleCopy = () => {
    navigator.clipboard.writeText(shareLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  const shareWhatsApp = () => {
    const text = encodeURIComponent(
      'Descobri algo incrível! Escreva uma carta para o seu eu do futuro e receba de volta quando chegar a hora. Uma experiência transformadora baseada em PNL. Experimente: ' + shareLink
    );
    window.open(`https://wa.me/?text=${text}`, '_blank', 'noopener,noreferrer');
  };

  const shareInstagram = () => {
    navigator.clipboard.writeText(shareLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  const shareFacebook = () => {
    const url = encodeURIComponent(shareLink);
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank', 'noopener,noreferrer');
  };

  const shareTwitter = () => {
    const text = encodeURIComponent(
      'Escrewi uma carta para o meu eu do futuro e foi transformador! Experimente você também:'
    );
    const url = encodeURIComponent(shareLink);
    window.open(`https://twitter.com/intent/tweet?text=${text}&url=${url}`, '_blank', 'noopener,noreferrer');
  };

  const shareEmail = () => {
    const subject = encodeURIComponent('Você precisa conhecer a Carta do Eu Futuro');
    const body = encodeURIComponent(
      'Oi!\n\nDescobri uma experiência incrível chamada Carta do Eu Futuro. Você escreve uma carta para a pessoa que vai se tornar e recebe de volta no momento certo.\n\nÉ baseada em PNL e realmente transforma a forma como você enxerga o futuro.\n\nExperimente: ' + shareLink + '\n\nVai valer a pena!'
    );
    window.open(`mailto:?subject=${subject}&body=${body}`);
  };

  return (
    <section id="convite-section" className="bg-luxury-cream py-28 relative">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent"></div>

      <div className="container mx-auto px-6 lg:px-16">
        <div className="flex items-center justify-center gap-4 mb-4">
          <div className="w-12 h-px bg-gold-500/40"></div>
          <span className="font-['Montserrat'] text-xs tracking-[0.3em] uppercase text-gold-600">
            Compartilhe
          </span>
          <div className="w-12 h-px bg-gold-500/40"></div>
        </div>

        <h2 className="font-['Playfair_Display'] text-4xl lg:text-5xl text-center text-luxury-charcoal mb-4">
          Convide quem importa
        </h2>
        <p className="font-['Montserrat'] text-sm text-luxury-charcoal/45 text-center max-w-lg mx-auto mb-16 font-light tracking-wide">
          Compartilhe seu link exclusivo e ajude pessoas queridas a viverem essa experiência transformadora
        </p>

        <div className="grid lg:grid-cols-2 gap-12 max-w-6xl mx-auto items-center">
          {/* Coluna esquerda - Link e compartilhamento */}
          <div>
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-gold-500/10">
              <div className="flex items-center gap-2 mb-6">
                <div className="w-6 h-6 rounded-full bg-gold-500/10 flex items-center justify-center">
                  <i className="ri-link text-gold-600 text-xs"></i>
                </div>
                <span className="font-['Montserrat'] text-xs font-medium text-gold-700 uppercase tracking-wider">
                  Seu Link de Convite
                </span>
              </div>

              <div className="flex items-center gap-3 mb-8">
                <div className="flex-1 bg-luxury-cream/60 border border-gold-500/15 rounded-lg px-4 py-3.5">
                  <p className="font-['Montserrat'] text-sm text-luxury-charcoal/70 truncate">
                    {shareLink}
                  </p>
                </div>
                <button
                  onClick={handleCopy}
                  className={`px-5 py-3.5 rounded-lg font-['Montserrat'] text-xs font-semibold tracking-wider uppercase transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2 ${
                    copied
                      ? 'bg-emerald-500 text-white'
                      : 'bg-gradient-to-r from-gold-500 to-gold-600 text-luxury-black hover:shadow-[0_0_20px_rgba(201,168,76,0.25)]'
                  }`}
                >
                  <i className={`${copied ? 'ri-check-line' : 'ri-file-copy-line'} text-sm`}></i>
                  {copied ? 'Copiado!' : 'Copiar'}
                </button>
              </div>

              <p className="font-['Montserrat'] text-xs text-luxury-charcoal/35 mb-5 tracking-wide">
                Ou compartilhe diretamente nas redes sociais:
              </p>

              <div className="grid grid-cols-5 gap-3">
                <button
                  onClick={shareWhatsApp}
                  className="flex flex-col items-center gap-2 p-4 rounded-xl border border-gold-500/10 hover:border-emerald-400/40 hover:bg-emerald-50/50 transition-all duration-300 cursor-pointer group"
                >
                  <div className="w-10 h-10 rounded-full bg-emerald-500/10 flex items-center justify-center group-hover:bg-emerald-500/20 transition-colors">
                    <i className="ri-whatsapp-fill text-emerald-600 text-lg"></i>
                  </div>
                  <span className="font-['Montserrat'] text-[10px] text-luxury-charcoal/40 group-hover:text-emerald-600 transition-colors">WhatsApp</span>
                </button>

                <button
                  onClick={shareInstagram}
                  className="flex flex-col items-center gap-2 p-4 rounded-xl border border-gold-500/10 hover:border-pink-400/40 hover:bg-pink-50/50 transition-all duration-300 cursor-pointer group"
                >
                  <div className="w-10 h-10 rounded-full bg-pink-500/10 flex items-center justify-center group-hover:bg-pink-500/20 transition-colors">
                    <i className="ri-instagram-fill text-pink-600 text-lg"></i>
                  </div>
                  <span className="font-['Montserrat'] text-[10px] text-luxury-charcoal/40 group-hover:text-pink-600 transition-colors">Instagram</span>
                </button>

                <button
                  onClick={shareFacebook}
                  className="flex flex-col items-center gap-2 p-4 rounded-xl border border-gold-500/10 hover:border-sky-400/40 hover:bg-sky-50/50 transition-all duration-300 cursor-pointer group"
                >
                  <div className="w-10 h-10 rounded-full bg-sky-500/10 flex items-center justify-center group-hover:bg-sky-500/20 transition-colors">
                    <i className="ri-facebook-fill text-sky-600 text-lg"></i>
                  </div>
                  <span className="font-['Montserrat'] text-[10px] text-luxury-charcoal/40 group-hover:text-sky-600 transition-colors">Facebook</span>
                </button>

                <button
                  onClick={shareTwitter}
                  className="flex flex-col items-center gap-2 p-4 rounded-xl border border-gold-500/10 hover:border-luxury-charcoal/30 hover:bg-luxury-charcoal/5 transition-all duration-300 cursor-pointer group"
                >
                  <div className="w-10 h-10 rounded-full bg-luxury-charcoal/10 flex items-center justify-center group-hover:bg-luxury-charcoal/15 transition-colors">
                    <i className="ri-twitter-x-fill text-luxury-charcoal text-lg"></i>
                  </div>
                  <span className="font-['Montserrat'] text-[10px] text-luxury-charcoal/40 group-hover:text-luxury-charcoal transition-colors">X</span>
                </button>

                <button
                  onClick={shareEmail}
                  className="flex flex-col items-center gap-2 p-4 rounded-xl border border-gold-500/10 hover:border-gold-500/40 hover:bg-gold-50/50 transition-all duration-300 cursor-pointer group"
                >
                  <div className="w-10 h-10 rounded-full bg-gold-500/10 flex items-center justify-center group-hover:bg-gold-500/20 transition-colors">
                    <i className="ri-mail-fill text-gold-700 text-lg"></i>
                  </div>
                  <span className="font-['Montserrat'] text-[10px] text-luxury-charcoal/40 group-hover:text-gold-700 transition-colors">Email</span>
                </button>
              </div>
            </div>

            {/* Estatísticas pessoais */}
            <div className="grid grid-cols-2 gap-4 mt-6">
              <div className="bg-white rounded-xl p-6 border border-gold-500/10 text-center">
                <p className="font-['Playfair_Display'] text-3xl font-bold text-gold-600 mb-1">0</p>
                <p className="font-['Montserrat'] text-[10px] text-luxury-charcoal/35 uppercase tracking-wider">Amigos convidados</p>
              </div>
              <div className="bg-white rounded-xl p-6 border border-gold-500/10 text-center">
                <p className="font-['Playfair_Display'] text-3xl font-bold text-gold-600 mb-1">0</p>
                <p className="font-['Montserrat'] text-[10px] text-luxury-charcoal/35 uppercase tracking-wider">Cartas criadas</p>
              </div>
            </div>
          </div>

          {/* Coluna direita - Imagem */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://public.readdy.ai/ai/img_res/25f934fb920568b4a655da1f5005b490.jpg"
                alt="Comunidade escrevendo cartas juntos"
                className="w-full h-[500px] object-cover object-top"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-8">
                <p className="font-['Playfair_Display'] text-2xl text-white mb-2 italic">
                  &ldquo;Juntos somos mais fortes&rdquo;
                </p>
                <p className="font-['Montserrat'] text-xs text-white/50 tracking-wide">
                  Cada convite é uma semente de transformação plantada em alguém que você ama
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConviteSection;
